import { SIGN_IN_SUCCESS, SIGN_OUT_SUCCESS, INIT_DATA } from './types/index';
import { getInits, setFirebaseRealTime, initializeDeliveryBDD } from '../apis/firebase';
import { getUserPermissions } from 'src/utils/admins';
import { Dispatch } from 'redux';

interface InitDatas {
  [key: string]: any;
}

interface UserPermissions {
  isAdminOfThisShop: boolean;
  isSuperAdmin: boolean;
  roleForCompany: string;
  shopWhereTheUserIsAdmin: string[];
  allowConnexion: boolean;
}

interface SignInSuccessPayload {
  initDatas: InitDatas;
  initializedApp: boolean;
  isAllShops: boolean;
  userPermissions: UserPermissions;
}

export const setLoggedInUser = (
  shopId: string,
  isAllShops: boolean,
  isShopChanged: boolean = false
) => async (dispatch: Dispatch) => {
  await initializeDeliveryBDD();

  const userPermissions: UserPermissions = await getUserPermissions(shopId);

  await setFirebaseRealTime(dispatch, shopId, userPermissions, isAllShops, isShopChanged);
  const { initDatas, initializedApp }: { initDatas: InitDatas, initializedApp: boolean } = await getInits(shopId, userPermissions, isAllShops);
  dispatch({
    type: SIGN_IN_SUCCESS,
    payload: { ...initDatas, initializedApp, isAllShops, userPermissions } as SignInSuccessPayload,
  });
};

export const intializingData = (isInitializing: boolean) => (dispatch: Dispatch) => {
  dispatch({ type: INIT_DATA, payload: isInitializing });
};

export const setLogOut = () => async (dispatch: Dispatch) => {
  dispatch({ type: SIGN_OUT_SUCCESS });
};
